<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useApplicationState} from "~/stores/application-state";

const {isLoading} = storeToRefs(useApplicationState())
const {showRegistration, showShouldConfirmEmailScreen, shouldShowResigningOfTerms} = storeToRefs(useAuthentication())

const showDrawerMenu = computed(() => {
  return !isLoading.value && !showRegistration.value && !showShouldConfirmEmailScreen.value && !shouldShowResigningOfTerms.value
})
</script>

<template>
  <LayoutAppContainer>
    <LayoutDrawer v-model="showDrawerMenu">
      <component :is="$route.meta.drawerMenu" v-if="$route.meta.drawerMenu"/>
      <EnvironmentDrawerMenu v-else/>
    </LayoutDrawer>


    <AuthUnconfirmedEmailScreen v-if="showShouldConfirmEmailScreen"></AuthUnconfirmedEmailScreen>
    <AuthRegistrationScreen v-else-if="showRegistration"></AuthRegistrationScreen>
    <AuthResignTermsScreen v-else-if="shouldShowResigningOfTerms"/>

    <v-main v-else>
      <NuxtPage/>
    </v-main>
  </LayoutAppContainer>
</template>
